import { DOWNLOAD_VAT_FILES } from '@constants/filing';

const vatFiles = {
  DRAFT_RETURN: {
    label: {
      id: 'global.actions.download-draft-menu-item',
      default: 'Draft Return Excel',
    },
    fileType: DOWNLOAD_VAT_FILES.DRAFT_RETURN,
  },
  FILED_RETURN: {
    label: {
      id: 'global.actions.download-filed-return-menu-item',
      default: 'Filed Return',
    },
    fileType: DOWNLOAD_VAT_FILES.FILED_RETURN,
  },
  SAFT: {
    label: {
      id: 'global.actions.download-saf-t-menu-item',
      default: 'SAF-T',
    },
    fileType: DOWNLOAD_VAT_FILES.SAFT,
  },
  XML: {
    label: {
      id: 'global.actions.download-official-xml-menu-item',
      default: 'XML',
    },
    fileType: DOWNLOAD_VAT_FILES.XML,
  },
};

export default vatFiles;
